import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
Vue.use(VueRouter);

import {enable_loading, disable_loading ,checkAuth, checkAccessMiddleware, checkPreventLogeIn, setPageTitleMiddleware} from "@/router/middleware"

// configure router
const router = new VueRouter({
  linkActiveClass: "active",
  mode: 'history',
  routes,
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

// router.beforeEach(enable_loading)
router.beforeEach(checkAccessMiddleware)
router.beforeEach(checkAuth)
router.beforeEach(checkPreventLogeIn)
router.beforeEach(setPageTitleMiddleware)
// router.afterEach(disable_loading)


export default router;
